import AddStoreForm from 'components/stores/addStoreForm';
import CommonLayout from 'layouts/DashboardLayout';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchStoreDetails } from '../../../redux/slices/storeSlice';
import AddStoreStiloForm from 'components/stores/addStoreStiloForm';
import { getData } from 'utilities/common';
import { STILO } from 'utilities/constants';
import { HEMP } from 'utilities/constants';

export default function AddStore() {
  const dispatch = useDispatch();
  const { storeId = '' } = useParams();
  const adminsMode = getData('adminsMode')
  const isHemp = JSON.parse(adminsMode) === HEMP
  useEffect(() => {
    if (storeId) {
      dispatch(fetchStoreDetails(storeId));
    }
  }, [storeId]);
  return (
    <CommonLayout>
      {
        !isHemp ?
          <AddStoreStiloForm />
          :
          <AddStoreForm />

      }
    </CommonLayout>
  );
}